import { VolumeRange } from '@studio/design-system/audio/volume';
import { PrefKeys } from './constants.js';
import { usePrefState } from '#~/preferences/hooks.js';
import type { UsePrefState } from '#~/preferences/hooks.js';

/**
 * Hook to mute/unmute the main output.
 *
 * @returns Main output mute state.
 */
export const useMutedPref = (): UsePrefState<boolean> => usePrefState(PrefKeys.muted, false);

/**
 * Hook to get/set the main output volume.
 *
 * @returns Main output volume.
 */
export const useVolumePref = (): UsePrefState<number> =>
  usePrefState(PrefKeys.volume, VolumeRange.max);
